import { LoadExamResults } from "../../services/ExamResultService";
import * as ActionTypes from "../ActionTypes";
export const LoadExamResultsAction = (id) => {
  return (dispatch) => {
    console.log("yes");
    dispatch({ type: ActionTypes.LOADING });
    LoadExamResults({ id }).then(
      (res) => {
        // console.log(res);
        if (res.hasOwnProperty("success") && res.success === true) {
          dispatch({ type: ActionTypes.LOAD_EXAMRESULTS_SUCCESS, res });
        } else if (res.hasOwnProperty("success") && res.success === false) {
          dispatch({ type: ActionTypes.LOAD_EXAMRESULTS_ERROR, res });
        }
      },
      (error) => {
        dispatch({ type: ActionTypes.CODE_ERROR, error });
      }
    );
  };
};
